import React, {createContext, useContext} from 'react';

import {usePanelBankConfig} from '../../../state/views/panelBankConfig/hooks';
import {useWorkspaceRefsContext} from '../../Workspace/WorkspaceRefsContext';
import type {PanelBankConfigWithRefs} from '../types';

const PanelBankConfigWithRefsValueContext = createContext<
  PanelBankConfigWithRefs | undefined
>(undefined);

export const PanelBankConfigWithRefsProvider: React.FC<{}> = ({children}) => {
  const {panelBankConfigRef} = useWorkspaceRefsContext();
  const panelBankConfig = usePanelBankConfig(panelBankConfigRef);

  return (
    <PanelBankConfigWithRefsValueContext.Provider value={panelBankConfig}>
      {children}
    </PanelBankConfigWithRefsValueContext.Provider>
  );
};

export function usePanelBankConfigWithRefs() {
  const context = useContext(PanelBankConfigWithRefsValueContext);
  if (context === undefined) {
    throw new Error(
      'usePanelBankConfigWithRefs must be used within a PanelBankConfigWithRefsProvider'
    );
  }
  return context;
}
